// Module
var code = "<div class=\"formHeader\">\n    <h3><span>Trainings - {{$ctrl.employee.firstName+' '+$ctrl.employee.lastName}}</span></h3>\n</div>\n<employees-trainings-grid title=\"Trainings\"></employees-trainings-grid>\n";
// Exports
module.exports = code;